import { Box, Paper, Typography } from "@mui/material";

function UserChatCard({ message }) {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                margin: 2
            }}
        >
            <Paper
                sx={{
                    maxWidth: "50%",
                    width: "fit-content",
                    backgroundColor: "#def0fc",
                    padding: 1.5,
                    borderRadius: 3,
                    display: "flex",
                    alignItems: "center",
                    boxShadow: 'none'
                }}
            >
                <Typography variant="body2">
                    {message}
                </Typography>
            </Paper>
        </Box>
    );
}

export default UserChatCard;
